import React from "react";
import { MDBContainer, MDBTypo } from "mdbreact";
import ReactMarkdown from "react-markdown";
import { Helmet } from "react-helmet";
import { Typography } from "@material-ui/core";
import Layout from "../components/Layout";

import ColourImage from "../components/ColourImage";

import text from "../text/text.json";

import songwriter from "../images/headers/SongHeader.jpg";
import songwriterSIDE from "../images/songwriterSIDE.jpg";

function Songwriter() {
  return (
    <>
      <Helmet>
        <title>Artistic Wizard | Songwriter</title>
      </Helmet>
      <Layout>
        <ColourImage text="" overlay="" image={songwriter} />
        <MDBContainer style={{ padding: "20px" }}>
          <ReactMarkdown>{text.songwriter.header1}</ReactMarkdown>
          <img src={songwriterSIDE} alt="" style={{float: 'right', margin: '10px', maxHeight:'50vh'}}/>
          <ReactMarkdown>{text.songwriter.body1}</ReactMarkdown>
          <ReactMarkdown>{text.songwriter.body2}</ReactMarkdown>
          <ReactMarkdown>{text.songwriter.body3}</ReactMarkdown>
          <MDBTypo>
            Keep up-to-date with upcoming live music events, new recordings and sample tracks via the links below:
          </MDBTypo>
          <MDBTypo>
            <a href="https://www.reverbnation.com/artist/artisticwizard">ReverbNation.com/artist/artisticwizard</a>
          </MDBTypo>
          <MDBTypo>
            <a href="https://www.triplejunearthed.com/artist/darren-conway">TripleJUnearthed.com/artist/darren-conway</a>
          </MDBTypo>
        </MDBContainer>
      </Layout>
    </>
  )
}

export default Songwriter;